// Reads tracking attribution (UTMs, click IDs, landing page, referrer) once at
// funnel start. Will be stored in FunnelContext (Step B) so every backend call
// can include it, even after the user navigates away from the landing URL.
// Keys + shape match backend V2Payload.tracking (V2Tracking) in v2_routes.py.

const PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid"
];

function emptyTracking() {
  return {
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
    utm_content: null,
    gclid: null,
    fbclid: null,
    landing_page: null,
    referrer: null
  };
}

export function readTracking() {
  const result = emptyTracking();
  try {
    const params = new URLSearchParams(window.location.search);
    for (const key of PARAM_KEYS) {
      const value = params.get(key);
      // Only overwrite when the param is present AND non-empty, so missing
      // params stay null (not "") for clean Google Sheet column alignment.
      if (value !== null && value.trim() !== "") {
        result[key] = value;
      }
    }
    result.landing_page = window.location.href;
    result.referrer = document.referrer || null;
    return result;
  } catch (err) {
    // SSR / sandboxed / no-window contexts: return the all-nulls shape.
    return emptyTracking();
  }
}
